import React, { useState } from 'react'
import EnquiryForm from './Enquiry/EnquiryForm'
import EnquiryFormSchoolAi from '../pages/newAiAssisant/components/EnquiryFormModal'
import ConfirmationPage from './Enquiry/ConfirmationPage'
import ConfirmationPageSchoolAi from './Enquiry/ConfirmationPageSchoolAi'
import CalendarModal from './shared/CalendarModal'

export default function SchoolAiPage({ onClose, enquiryType, otpRequired = true }) {
  const [step, setStep] = useState(0);
  const isAiAssistForm = enquiryType === 'Aiassistform'
  return (
    <React.Fragment>
      {step === 0 && (
        isAiAssistForm ? (
          <EnquiryFormSchoolAi
            handleUpdateStep={setStep}
            onClose={onClose}
          />
        ) : (
          <EnquiryForm
            handleUpdateStep={setStep}
            onClose={onClose}
            otpRequired={otpRequired}
          />
        )
      )}
      {step === 1 && (
        isAiAssistForm ? (
          <ConfirmationPageSchoolAi onClose={onClose} />
        ) : (
          <ConfirmationPage handleUpdateStep={setStep} onClose={onClose} />
        )
      )}
      {!isAiAssistForm && step === 2 && (
        <CalendarModal onClose={onClose} />
      )}
    </React.Fragment>
  )
}
